import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2
} from '@angular/core';
import { TooltipService } from 'src/app/components/shared/layout/shared/tooltip.service';
import { ToastService } from '../../services/toast-service/toast.service';

@Directive({
  selector: '[appCopyToClipboard]',
})
export class CopyToClipboardDirective implements OnDestroy {
  @Input('appCopyToClipboard') textToCopy: string = '';
  @Input() copyLabel?: string;

  @Input() copyTooltip = 'Click to copy';
  @Input() tooltipPosition: 'top' | 'bottom' | 'auto' = 'auto';
  @Input() tooltipDelay = 300;

  @Input() copiedMessage?: string;

  private showTimer: any;
  private justCopied = false;

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
    private tooltipService: TooltipService,
    private toastService: ToastService
  ) {
    this.renderer.setStyle(
      this.elRef.nativeElement,
      'cursor',
      'pointer'
    );
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (this.justCopied) return;
    if (!this.copyTooltip?.trim()) return;

    this.showTimer = setTimeout(() => {
      this.tooltipService.showTooltip(
        this.copyTooltip,
        this.elRef.nativeElement,
        this.tooltipPosition
      );
    }, this.tooltipDelay);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    clearTimeout(this.showTimer);
    this.tooltipService.hideTooltip(100);
  }

  @HostListener('click', ['$event'])
  async onClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    clearTimeout(this.showTimer);
    this.tooltipService.hideTooltip(0);

    this.justCopied = true;
    setTimeout(() => (this.justCopied = false), 400);

    const text =
      this.textToCopy?.trim() ||
      this.elRef.nativeElement?.innerText?.trim() ||
      '';

    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);

      let message = 'Text is copied to clipboard';

      if (this.copiedMessage?.trim()) {
        message = this.copiedMessage.trim();
      } else if (this.copyLabel?.trim()) {
        const label = this.copyLabel.trim();
        const formatted =
          label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
        message = `${formatted} is copied to clipboard`;
      }

      this.toastService.show(message);
    } catch {
      this.toastService.show('Copy failed');
    }
  }

  ngOnDestroy() {
    clearTimeout(this.showTimer);
    this.tooltipService.hideTooltip();
  }
}
